import { INTERNAL_EMAIL_DOMAINS } from "constants/internalEmailDomains";

export const isInternalEmail = (email?: string | null): boolean => {
  const normalizedEmail = email?.trim().toLowerCase() ?? "";

  return INTERNAL_EMAIL_DOMAINS.some((domain) =>
    normalizedEmail.endsWith(domain)
  );
};
